import { render, staticRenderFns } from "./PluginLeadModal.vue?vue&type=template&id=4862f2d3&scoped=true"
import script from "./PluginLeadModal.vue?vue&type=script&lang=js"
export * from "./PluginLeadModal.vue?vue&type=script&lang=js"
import style0 from "./PluginLeadModal.vue?vue&type=style&index=0&id=4862f2d3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4862f2d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4862f2d3')) {
      api.createRecord('4862f2d3', component.options)
    } else {
      api.reload('4862f2d3', component.options)
    }
    module.hot.accept("./PluginLeadModal.vue?vue&type=template&id=4862f2d3&scoped=true", function () {
      api.rerender('4862f2d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginLeadModal.vue"
export default component.exports